import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function submitBooking(data, files) {
  const payload = {
    brand: data.brand, model: data.model, year: data.year, mileage: data.mileage, plate: data.plate,
    service: data.service, message: data.message, preferred_date: data.date, preferred_time: data.time,
    name: data.name, phone: data.phone, email: data.email, photos: files.map((f) => f.name),
  };
  const res = await axios.post(`${API}/appointments`, payload);

  const key = process.env.REACT_APP_WEB3FORMS_KEY;
  let emailed = false;
  if (key) {
    const fd = new FormData();
    fd.append("access_key", key);
    fd.append("subject", `Neue Terminanfrage – ${data.service} – ${data.brand} ${data.model}`);
    fd.append("from_name", "NIVO GARAGE Website");
    fd.append("botcheck", "");
    fd.append("Referenz", res.data.id);
    fd.append("Fahrzeug", `${data.brand} ${data.model} ${data.year ? `(${data.year})` : ""}`.trim());
    fd.append("Kilometerstand", data.mileage || "–");
    fd.append("Kontrollschild", data.plate || "–");
    fd.append("Service", data.service);
    fd.append("Anliegen", data.message || "–");
    fd.append("Wunschtermin", `${data.date} ${data.time}`.trim());
    fd.append("name", data.name);
    fd.append("Telefon", data.phone);
    fd.append("email", data.email);
    files.forEach((f) => fd.append("attachment", f));
    try {
      const r = await fetch("https://api.web3forms.com/submit", { method: "POST", body: fd });
      const j = await r.json();
      emailed = Boolean(j.success);
    } catch {
      emailed = false;
    }
  }
  return { id: res.data.id, emailed, configured: Boolean(key) };
}
